export { detectMobileOS, detectDesktopBrowser, browser, mobileOS, touch, msPointers, pointers, touchEnabled } from './support';
export { getter } from './accessors/getter';
export { setter } from './accessors/setter';
